// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Participant {\n  height: 130px;\n  width: 148px;\n  position: relative;\n  overflow: hidden;\n  margin: auto;\n}\n\n.title {\n  z-index: 1000000;\n}\n", ""]);
// Exports
module.exports = exports;
